<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Cadastro de fonte de midia
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-select
            v-model="provider"
            :items="providers"
            :error-messages="formErrors.provider"
            :rules="rulesProvider"
            label="Provedor"
          />
          <v-text-field
            v-model="url"
            :error-messages="formErrors.data"
            :rules="rulesData"
            label="link"
            @input="formErrors.data = ''"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="addSourceToMedia()"
          >
            Incluir
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
  },
  mixins: [
    handlesServerValidation
  ],

  props: {
    mediaId: { type: [String, Number], required: true }
  },

  data: () => ({
    rulesProvider: [
      value => !!value || 'Provider é obrigatório.'
    ],
    rulesData: [
      v => !!v || 'link é obrigatório'
    ],
    provider: 'youtube',
    url: null,
    providers: ['youtube']
  }),
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  created () {
  },
  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async addSourceToMedia () {
      const mediaId = parseInt(this.mediaId)
      const data = {
        provider: this.provider,
        data: this.url
      }
      try {
        await this.$api.addSourceToMedia(mediaId, data)
        this.$emit('resolve', true)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível adicionar o fonte de mídia, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
      this.loading = false
    }
  }
}
</script>
